import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    bgColor: String,
  };
  static targets = ["button", "slider", "field"];

  connect() {
    console.log(typeof this.fieldTarget.value);
    if (this.fieldTarget.value == "true") {
      this.on();
    }
  }

  toggle() {
    if (this.isOn) {
      this.off();
    } else {
      this.on();
    }
  }

  on() {
    this.isOn = true;
    this.buttonTarget.classList.remove("bg-gray-200");
    this.buttonTarget.classList.add(this.bgColorValue);
    this.sliderTarget.classList.add("translate-x-5");
    this.sliderTarget.classList.remove("translate-x-0");
    this.fieldTarget.value = 1;
  }

  off() {
    this.isOn = false;
    this.buttonTarget.classList.add("bg-gray-200");
    this.buttonTarget.classList.remove(this.bgColorValue);
    this.sliderTarget.classList.remove("translate-x-5");
    this.sliderTarget.classList.add("translate-x-0");
    this.fieldTarget.value = 0;
  }
}
